"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("./utils");
const lang = __importStar(require("./lang.json"));
const ssn_logo_svg_1 = __importDefault(require("./assets/images/ssn_logo.svg"));
require("./footer.css");
;
/**
 * Main component.
 * @name footer
 * @param {FooterProps}
 * @returns {<Footer />}
*/
const Footer = ({ links = [], legalText = '' }) => {
    return (react_1.default.createElement("footer", { "data-testid": "footer-element", className: "footer-container" },
        react_1.default.createElement("div", { className: "d-none d-lg-flex pt-3 pb-3" },
            react_1.default.createElement("div", { className: "links-container" }, (0, utils_1.renderLinks)(links))),
        react_1.default.createElement("div", { className: "d-none d-lg-flex pt-3 pb-3" },
            react_1.default.createElement("p", { className: "legal-text" }, legalText.toUpperCase()),
            react_1.default.createElement("a", { href: lang.ssnUrl, className: "pl-3" },
                react_1.default.createElement("img", { src: ssn_logo_svg_1.default, alt: lang.imgAlt }))),
        react_1.default.createElement("div", { className: "row align-items-center d-lg-none" },
            react_1.default.createElement("p", { className: "col-8 pr-0 legal-text" }, legalText.toUpperCase()),
            react_1.default.createElement("a", { className: "col-4 pl-0", href: lang.ssnUrl },
                react_1.default.createElement("img", { src: ssn_logo_svg_1.default, alt: lang.imgAlt, className: "pl-0 w-100" })))));
};
exports.Footer = Footer;
__exportStar(require("./utils"), exports);
//# sourceMappingURL=footer.js.map